import { Box } from "@chakra-ui/react";
import Head from "next/head";
import Script from "next/script";
import { useEffect } from "react";

// colorBtn = "#E74C3C",
const colorBtn = "#03c183";
const affiliateName = "UlovDomov.cz";
const affiliateId = "630e55292da5c3298196c931";
const password = "IOnTti9BpPNg280TDO";

export const HypoWidget = ({}) => {
  useEffect(() => {
    setTimeout(() => {
      setButtonSize();
      setOnclick();
    }, 1000);
  }, []);

  const setButtonSize = () => {
    const container = document.getElementById("hypo-div");
    const button =
      container?.children[0].shadowRoot?.querySelector(".mat-raised-button");
    if (button) {
      // @ts-expect-error widget
      button.style.fontSize = "18px";
      // @ts-expect-error widget
      button.style.padding = "0px";
    }
  };

  const setOnclick = () => {
    const container = document.getElementById("hypo-div");
    const tabs = container?.children[0].shadowRoot?.querySelector(".tabs");
    if (tabs) {
      // @ts-expect-error widget
      tabs.onclick = () => {
        setButtonSize();
      };
    }
  };

  return (
    <>
      <Head>
        <link
          rel="stylesheet"
          href={
            process.env.NODE_ENV === "production"
              ? "https://cdn.hyponamiru.cz/widget/hyponamiru-calculator-widget.css"
              : "https://cdn.hyponamiru.cz/widget/hyponamiru-calculator-widget-development.css"
          }
        />
      </Head>
      <Box mt={["24px", "54px"]} mb={["24px", "54px"]} id="hypo-div">
        <>
          <Script
            src={
              process.env.NODE_ENV === "production"
                ? "https://cdn.hyponamiru.cz/widget/hyponamiru-calculator-widget.js"
                : "https://cdn.hyponamiru.cz/widget/hyponamiru-calculator-widget-development.js"
            }
          />
          {/* @ts-ignore */}
          <hyponamiru-widget
            affiliate-id={affiliateId}
            affiliate-name={affiliateName}
            password={password}
            // container-color=""
            // ring-color=""
            // hover-color=""
            main-button-color={colorBtn}
            // main-button-shape=""
            // ring-color="red"
            // // main-button-shape="square-rounded"
            // // radio-button-color="yellow"
            // affiliate-name={affiliateName}
            // affiliate-id={affiliateId}
          />
        </>
      </Box>
    </>
  );
};
